import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Query } from 'react-apollo'
import { message } from 'antd'
import _ from 'lodash'
import {
  Div, H5, LoadingIcon, P, Icon,
} from 'konsys-ui'
import { Step3 } from '../quotation-request'
import { status } from '../../constants/status'
import { CenterContainerMsg, CenterContainerWentWrongMsg } from '../../components/common/container-msg'
import { GET_QUOTATION_DETAIL, GET_PROFILE } from '../../constants/graph/query'
import Container from '../../components/container'
import QueryEditProfile from '../../components/profile'
import HistoryTable from '../history-page'
import ChangePassword from '../change-password'
import PATH from '../../constants/path'
import { removeAccessToken } from '../../utils/local-data-service'
import Banner from '../../images/member/banner.jpg'
import { theme, screenSize } from '../../styles/_variables'
import {
  TabContainerWrapper, TabTitleWrapper, WidthContainer, ContentContainer,
} from './styled'


const SummaryData = ({
  stepOneData,
  stepTwoData,
  isPredefined,
  formValues,
  onChangeTab,
  activeTab,
}) => (
  <Step3
    stepOneData={stepOneData}
    stepTwoData={stepTwoData}
    isSummaryInProfile
    isPredefined={isPredefined}
    formValues={formValues}
    onChangeTab={onChangeTab}
    activeTab={activeTab}
  />
)

const TextTitleRow = ({
  title,
  data,
  textColor,
  isMobileXL,
}) => (
  <Div display='flex' justifyContent='space-between'>
    <Div flexBasis={isMobileXL ? '31%' : '35%'} padding={isMobileXL ? '8px 18px' : '8px 30px'} margin={isMobileXL ? '0px 6px 0px 16px' : '0px 16px'} bgColor={theme.color.primaryColor}>
      <H5 color={theme.color.offWhite} style={{ fontSize: isMobileXL && theme.fonts.size.small }}>{title}</H5>
    </Div>
    <Div padding={isMobileXL ? '8px 0px' : '8px 24px'} margin='0 16px'>
      <H5 color={textColor} style={{ fontSize: isMobileXL && theme.fonts.size.small }}>{data}</H5>
    </Div>
  </Div>
)

const QuerySummaryData = ({
  id,
  onError,
  activeTab,
  onChangeTab,
  isMobileXL,
}) => (
  <Query
    query={GET_QUOTATION_DETAIL}
    variables={{
      quotationId: id,
    }}
    fetchPolicy='network-only'
  >
  {
    ({ loading, data }) => {
      if (loading) return <LoadingIcon fullWidth center />
      if (!data.quotation.success) {
        onError()
        message.error(data.quotation.message)
        return null
      }
      const quotationData = data.quotation.quotation
      const statusHistoryList = quotationData.statusHistory
      const omitData = _.omit(quotationData, [
        'address',
        'shippingAddress',
        'useCompleteDesign',
        'adminNote',
        '__typename',
        'status',
        'quotationId',
        'refId',
        'statusHistory',
        'taxRate',
        'totalPrice',
        'createdAt',
        'shipping',
        'billingPDF',
        'billing2PDF',
        'quotationPDF',
      ])

      const formValues = {
        partData: omitData && omitData.partDetail.map(item => ({
          packagePartName: item.packagePartName,
          packageData: {
            name: omitData.name,
          },
          sizeList: {
            a: _.isNumber(item.sizeA) ? item.sizeA : -1,
            b: _.isNumber(item.sizeB) ? item.sizeB : -1,
            c: _.isNumber(item.sizeC) ? item.sizeC : -1,
            d: _.isNumber(item.sizeD) ? item.sizeD : -1,
            e: _.isNumber(item.sizeE) ? item.sizeE : -1,
            f: _.isNumber(item.sizeF) ? item.sizeF : -1,
            g: _.isNumber(item.sizeG) ? item.sizeG : -1,
            h: _.isNumber(item.sizeH) ? item.sizeH : -1,
            i: _.isNumber(item.sizeI) ? item.sizeI : -1,
            j: _.isNumber(item.sizeJ) ? item.sizeJ : -1,
          },
          measurementUnit: {
            label: item.unitSize === 'cm' ? 'ซม.' : 'นิ้ว',
          },
          paper: {
            name: item.paperType,
            selectedThickness: item.paperThickness,
          },
          coating: {
            coatingType: (item.coatingFront && item.coatingBehind) ? 'เคลือบสองหน้า' : (!item.coatingFront && item.coatingBehind) ? 'เคลือบด้านหลัง' : (item.coatingFront && !item.coatingBehind) ? 'เคลือบด้านหน้า' : 'ไม่เคลือบ',
            coatingFrontName: item.coatingFront,
            coatingBackName: item.coatingBehind,
          },
          spotUV: {
            spotUVType: (item.spotUVFront && item.spotUVBehind) ? 'เคลือบสองหน้า' : (!item.spotUVFront && item.spotUVBehind) ? 'เคลือบด้านหลัง' : (item.spotUVFront && !item.spotUVBehind) ? 'เคลือบด้านหน้า' : 'ไม่เคลือบ',
            spotUVFrontName: item.spotUVFront,
            spotUVBackName: item.spotUVBehind,
          },
          embossing: item.quotationEmbossing.map(x => ({
            ...x,
            lengths: x.length,
          })),
          foiling: item.quotationFoiling.map(x => ({
            ...x,
            lengths: x.length,
          })),
          plasticWindow: item.quotationPlasticWindow.map(x => ({
            ...x,
            lengths: x.length,
          })),
          printing: {
            printingName: item.printingName,
            printingTypeName: item.printingSide === 1 ? 'พิมพ์หน้าเดียว' : item.printingSide === 2 ? 'พิมพ์สองหน้า' : '',
            printingBasicColorName: item.printingBasicColor,
            printingExtraColorId: item.quotationPrintingExtraColor.map(x => ({ printingExtraColorName: x.printingExtraColor })),
          },
        })),
      }

      const stepOneData = Object.keys(omitData).reduce((acc, key) => {
        const newResult = { ...acc }
        if (key === 'useBoxSuitDesign') {
          newResult.boxSuitDesignService = quotationData.useBoxSuitDesign ? 'useDesign' : 'notUseDesign'
        } else if (key === 'designServiceChoice') {
          newResult.designServiceChoice = quotationData.useCompleteDesign ? 'useDesignService' : 'notUseDesignService'
        } else if (key === 'width' || key === 'length' || key === 'height') {
          if (quotationData.width && quotationData.height && quotationData.length && key === 'width') {
            newResult.boxSize = {
              width: quotationData.width,
              height: quotationData.height,
              length: quotationData.length,
            }
          }
        } else if (key === 'designInfo') {
          if (!_.isEmpty(omitData.designInfo)) {
            if (quotationData.designInfo && quotationData.designInfo.width && quotationData.designInfo.height) {
              newResult.productSize = {
                width: quotationData.designInfo.width,
                height: quotationData.designInfo.height,
                length: quotationData.designInfo.length,
              }
            }
            if (_.isNumber(quotationData.designInfo.quantity) && quotationData.designInfo.quantity > 0) {
              newResult.productQuantityPerPiece = quotationData.designInfo.quantity
            }
            if (!_.isEmpty(quotationData.designInfo.description)) {
              newResult.designDescription = quotationData.designInfo.description
            }
          }
        } else {
          newResult[key] = omitData[key]
        }
        return newResult
      }, {})

      const stepTwoData = {
        taxData: Object.assign({}, _.omit(quotationData.address, ['__typename'])),
        shipData: Object.assign({}, _.omit(quotationData.shippingAddress, ['__typename'])),
      }
      const currentStatusData = _.find(status, d => d.key === quotationData.status)
      return (
        <Div>
          <Div margin='0 0 40px'>
            <TextTitleRow isMobileXL={isMobileXL} title='หมายเลขอ้างอิง' data={quotationData.refId} />
            <TextTitleRow isMobileXL={isMobileXL} title='วันที่ / เวลา' data={moment(quotationData.createdAt).format('DD/MM/YYYY HH:mm').replace(' ', '\xa0\xa0\xa0\xa0\xa0')} />
            <TextTitleRow isMobileXL={isMobileXL} textColor={currentStatusData.color} title='สถานะ' data={currentStatusData.text} />
          </Div>
          {
            currentStatusData.key === 'shipped' && !_.isEmpty(quotationData.shipping)
            && <Div margin='0 0 40px'>
              <TextTitleRow title='ผู้จัดส่ง' data={quotationData.shipping.shipper} />
              <TextTitleRow title='หมายเลขติดตามการจัดส่ง' data={quotationData.shipping.trackingId} />
              {
                (quotationData.billingPDF || quotationData.billing2PDF)
                && <Div display='flex' justifyContent='space-between'>
                  <Div flexBasis='35%' padding='8px 24px' margin='0 16px' bgColor={theme.color.primaryColor}>
                    <H5 color={theme.color.offWhite}>ใบเสร็จรับเงินและใบกำกับภาษี</H5>
                  </Div>
                  <Div textAlign='right' flexBasis='50%' padding='8px 24px' margin='0 16px'>
                  {
                    quotationData.billingPDF
                    && <a href={quotationData.billingPDF} target="_blank" rel="noopener noreferrer">
                      <H5 style={{ textDecoration: 'underline' }}>คลิกเพื่อดาวน์โหลดไฟล์แรก</H5>
                    </a>
                  }
                  {
                    quotationData.billing2PDF
                    && <a href={quotationData.billing2PDF} target="_blank" rel="noopener noreferrer">
                      <H5 style={{ textDecoration: 'underline' }}>คลิกเพื่อดาวน์โหลดไฟล์ที่สอง</H5>
                    </a>
                  }
                  </Div>
                </Div>
              }
            </Div>
          }
          {
            statusHistoryList && statusHistoryList.length > 0 && <Div margin='0 0 40px'>
              <H5 display='block' padding='8px 24px' margin='0 16px' style={{ backgroundColor: theme.color.primaryColor }} color={theme.color.offWhite}>ประวัติสถานะ</H5>
              {
                statusHistoryList.map((v, i) => {
                  const statusData = _.find(status, d => d.key === v.status)
                  return (
                    <Div
                      key={i}
                      display='flex'
                      justifyContent='space-between'
                      padding='8px 24px'
                      margin='0 16px'
                      bgColor={theme.color.lightPaleGrey}
                      moreStyle={{ borderBottom: `1px solid ${theme.color.paleGray}` }}
                    >
                      <Div>
                        <H5 color='#626262' margin='0 40px 0 0'>{v.dateTime.split(' ')[0]}</H5>
                        <H5 color='#626262'>{v.dateTime.split(' ')[2]}</H5>
                      </Div>
                      <H5 color={statusData.color}>{statusData.text}</H5>
                    </Div>
                  )
                })
              }
            </Div>
          }
          {
            quotationData.quotationPDF
            && <Div margin='0 0 40px' display='flex' justifyContent='space-between'>
              <Div flexBasis='35%' padding='8px 24px' margin='0 16px' bgColor={theme.color.primaryColor}>
                <H5 color={theme.color.offWhite}>ใบเสนอราคา</H5>
              </Div>
              <Div textAlign='right' flexBasis='50%' padding='8px 24px' margin='0 16px'>
                <a href={quotationData.quotationPDF} target="_blank" rel="noopener noreferrer">
                  <H5 color={'#6F6E6E'} style={{ textDecoration: 'underline', textAlign: 'right' }}>คลิกเพื่อดาวน์โหลดใบเสนอราคา</H5>
                </a>
              </Div>
            </Div>
          }

          <SummaryData
            stepOneData={stepOneData}
            stepTwoData={stepTwoData}
            isPredefined={omitData.isPreDefine}
            formValues={formValues}
            activeTab={activeTab}
            onChangeTab={onChangeTab}
          />
        </Div>
      )
    }
  }
  </Query>
)

const TabTitle = ({
  title, active, onClick, icon,
}) => (
  <TabTitleWrapper title={title} icon={icon} onClick={() => onClick()} active={active} color={title === 'ออกจากระบบ' ? '#000000' : '#C9C9C9'}>
    <H5>{title}</H5>
  </TabTitleWrapper>
)


const TabContainer = ({ isSocialLogin, children }) => {
  const [activeTab, setActiveTab] = useState(1)
  const [windowSize, setWindowSize] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth)
    })
  })

  const menu = [
    { icon: '', index: 1, title: 'แก้ไขข้อมูลส่วนตัว' },
    { icon: '', index: 2, title: 'ตรวจสอบประวัติคำขอใบเสนอราคา และคำสั่งพิมพ์' },
  ]

  if (!isSocialLogin) {
    menu.push({ icon: '', index: 3, title: 'เปลี่ยนรหัสผ่าน' })
  }

  return (
    <TabContainerWrapper activeTab={activeTab} title={menu[activeTab - 1].title}>
      <Div
        style={{
          boxShadow: 'rgb(17 17 26 / 30%) 0px 0px 4px',
          height: '100%',
          display: 'block',
        }}
      >
      {
        menu.map(v => (
          <TabTitle
            key={v.index}
            icon={v.icon}
            active={activeTab === v.index}
            onClick={() => setActiveTab(v.index)}
            title={v.title}
          />
        ))
      }
      {
        windowSize > screenSize.tablet
        && <TabTitle title='ออกจากระบบ' onClick={() => {
          removeAccessToken()
          message.success('ออกจากระบบเรียบร้อย')
          setTimeout(() => {
            window.location = PATH.home
          }, 1000)
        }}/>
      }
      </Div>
      {
        // <ContentContainer overflowHidden={ activeTab === 1}></ContentContainer>
      }
      <ContentContainer overflowHidden={activeTab === 1}>
      {
        children[activeTab - 1]
      }
      </ContentContainer>
    </TabContainerWrapper>
  )
}

const Member = () => {
  const [isShowDetail, setShowDetail] = useState(false)
  const [selectedId, setSelectedId] = useState(0)
  const [activeTabSummary, setActiveTabSummary] = useState(0)

  const onChangeTab = (key) => {
    setActiveTabSummary(key)
  }

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 375)
  const [isMobileXL, setIsMobileXL] = useState(window.innerWidth <= 570)

  const screenSizeHandler = () => setIsMobileView(window.innerWidth <= 375)
  const screenSizeHandler2 = () => setIsMobileXL(window.innerWidth <= 570)

  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    window.addEventListener('resize', screenSizeHandler2)
    return () => {
      window.removeEventListener('resize', screenSizeHandler)
      window.removeEventListener('resize', screenSizeHandler2)
    }
  }, [])
  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'บัญชีผู้ใช้',
        color: theme.color.tertiaryColor,
      }}
      backgroundColor={theme.color.offWhite}
    >
      <WidthContainer padding='40px 16px'>
        <Query
          query={GET_PROFILE}
        >
        {
          ({ loading, data }) => {
            if (loading || !data) {
              return (
                <CenterContainerMsg>
                  <LoadingIcon color={theme.color.lightPaleGrey} />
                </CenterContainerMsg>
              )
            }
            if (!data.showProfile.success) {
              message.error(data.showProfile.message)
              return <CenterContainerWentWrongMsg title='ระบบมีปัญหา กรุณาลองใหม่ภายหลัง' />
            }
            return (
              <TabContainer isSocialLogin={data.showProfile.isSocialLogin}>
                <QueryEditProfile />
                {
                  isShowDetail
                    ? <Div>
                      <P style={{ cursor: 'pointer' }} margin='0 16px 24px' onClick={() => setShowDetail(false)}>
                        <Icon fontSize={theme.fonts.size.label} icon='far fa-arrow-left' margin='0 8px 0 0' />ย้อนกลับ
                      </P>
                      <QuerySummaryData
                        id={selectedId}
                        onError={() => setShowDetail(false)}
                        activeTab={activeTabSummary}
                        onChangeTab={onChangeTab}
                        isMobileXL={isMobileXL}
                      />
                    </Div>
                    : <HistoryTable onSelect={(id) => {
                      setShowDetail(true)
                      setSelectedId(id)
                    }}/>
                }
                <ChangePassword />
              </TabContainer>
            )
          }
        }
        </Query>
      </WidthContainer>
    </Container>
  )
}

export default Member



// WEBPACK FOOTER //
// ./src/pages/member/index.jsx